export default __webpack_public_path__ + "static/media/Laura.04a8c106.jpg";